import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = ["id", "name", "value"]
const _hoisted_2 = ["for"]
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputErrorMessage = _resolveComponent("InputErrorMessage")!
  const _component_Field = _resolveComponent("Field")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-checkbox", { 'pb-x6': _ctx.showErrors }])
  }, [
    _createVNode(_component_Field, {
      modelValue: _ctx.internalValue,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.internalValue) = $event)),
      name: _ctx.name,
      rules: _ctx.fieldRules,
      type: "radio",
      value: _ctx.value
    }, {
      default: _withCtx(({ field, errorMessage }) => [
        _createElementVNode("input", _mergeProps({ id: _ctx.fieldId }, { ..._ctx.$attrs, ...field }, {
          type: "radio",
          name: _ctx.name,
          value: _ctx.value,
          class: [{ 'c-checkbox__field--error': !!errorMessage }, "c-checkbox__field"]
        }), null, 16, _hoisted_1),
        _createElementVNode("label", {
          for: _ctx.fieldId,
          class: _normalizeClass(["c-checkbox__label-radio", {'c-checkbox__label-radio--top-alignment': _ctx.alignLabelWithTop,
                            'c-checkbox__label-radio--hidden': _ctx.hideLabel}])
        }, [
          (_ctx.label)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.label), 1))
            : (_ctx.htmlLabel)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 1,
                  innerHTML: _ctx.htmlLabel
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true)
        ], 10, _hoisted_2),
        (_ctx.showErrors)
          ? (_openBlock(), _createBlock(_component_InputErrorMessage, {
              key: 0,
              name: _ctx.name,
              class: "c-checkbox__errors"
            }, null, 8, ["name"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue", "name", "rules", "value"])
  ], 2))
}